import { Text } from '@reckon-web/text';
import { TextLinkButton } from '@reckon-web/text-link';
import { LoadingDots } from '@reckon-web/loading';
import { Flex } from '@reckon-web/flex';
import { makeId } from '@reckon-web/utils';

import { useOpenJobDialog } from '../../../../../hooks/use-open-job-dialog';
import { useQueryJobLink } from '../../../../../hooks/use-query-job-link';

// TODO move this somewhere shared

type JobLinkType = {
  job_cloudId: string;
  job_name: string;
  isBold?: boolean;
  displayLoadingDots?: boolean;
  onBeforeLinkClick?: () => void;
  onAfterLinkClick?: () => void;
  testId?: string;
};

export const JobLink = ({
  job_cloudId,
  job_name,
  isBold = true,
  displayLoadingDots,
  onBeforeLinkClick,
  onAfterLinkClick,
  testId = `job-link`,
}: JobLinkType) => {
  const openJob = useOpenJobDialog();
  const { data, loading } = useQueryJobLink(job_cloudId);

  if (loading)
    return displayLoadingDots ? (
      <Flex>
        <LoadingDots
          label="Loading task"
          size="small"
          data-testid={makeId(testId, 'loading-task')}
        />
      </Flex>
    ) : (
      <Text
        size="small"
        weight={isBold ? 'semibold' : 'regular'}
        inline
        overflowStrategy="breakword"
        data={{ testid: makeId(testId, 'job-name') }}
      >
        {job_name}
      </Text>
    );

  if (!data) {
    return (
      <Text
        size="small"
        weight={isBold ? 'semibold' : 'regular'}
        inline
        overflowStrategy="breakword"
        data={{ testid: makeId(testId, 'job-name-unknown') }}
      >
        {job_name} (unknown job)
      </Text>
    );
  }

  if (data.job.WfDeletedOnUTC) {
    return (
      <Text
        size="small"
        inline
        color="dim"
        overflowStrategy="breakword"
        data={{ testid: makeId(testId, 'job-name-deleted') }}
      >
        {job_name} (deleted)
      </Text>
    );
  }

  return (
    <Text inline overflowStrategy="breakword">
      <TextLinkButton
        color="base"
        onClick={async () => {
          if (onBeforeLinkClick) {
            onBeforeLinkClick();
          }
          await openJob(data.job.cloudId);
          if (onAfterLinkClick) {
            onAfterLinkClick();
          }
        }}
        data-testid={makeId(testId, 'text-link')}
      >
        {data.job.name} ({data.client?.name})
      </TextLinkButton>
    </Text>
  );
};
